<div class="nav-container">

  <nav id="main-menu-navigation" class="navigation-main">
  <!-- <div class="nav-item"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a [routerLink]="['/']"  ngbTooltip="{{'menu.Home' | translate}}"> <img src="assets/images/home5.png" class="img-fluid" alt="SEU"><span>{{'menu.Home' | translate}}</span></a>
  </div> -->
 

  


  <!-- <div class="nav-item has-sub open  ">
      <a href="javascript:void(0)"  ngbTooltip="{{'admin.questionsmanagment' | translate}}"> <img src="assets/images/question.png" class="img-fluid" alt="SEU"><span>{{'admin.questionsmanagment' | translate}}</span></a>
      <div class="submenu-content">
          <a  id="mnquestbankform"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-item" [routerLink]="['/auth/basic-data/question-banks-form']"> <img src="assets/images/addb.png" class="img-fluid" alt="SEU">{{'admin.questionbank' | translate}}</a>
          <a id="mnquestview"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-item" [routerLink]="['/auth/basic-data/questions-view']"> <img src="assets/images/question2.png" class="img-fluid" alt="SEU">{{'admin.questions' | translate}}</a>
          <a id="mnquestform"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-item" [routerLink]="['/auth/basic-data/questions-form']"> <img src="assets/images/plusq.png" class="img-fluid" alt="SEU">{{'general.addquestion' | translate}}</a>
      </div>
  </div> -->
<!-- 
  <div class="nav-item has-sub open ">
      <a href="javascript:void(0)"  ngbTooltip="{{'admin.exammanagment' | translate}}"> <img src="assets/images/question.png" class="img-fluid" alt="SEU"><span>{{'admin.exammanagment' | translate}}</span></a>
      <div class="submenu-content">
          <a id="mnexamview" routerLinkActive="active"  [routerLinkActiveOptions]="{exact: true}" class="menu-item" [routerLink]="['/auth/basic-data/exam-view']"> <img src="assets/images/manual.png" class="img-fluid" alt="SEU">{{'admin.exam' | translate}}</a>
          <a id="mnexamform" routerLinkActive="active"  [routerLinkActiveOptions]="{exact: true}" class="menu-item" [routerLink]="['/auth/basic-data/exam-form']"> <img src="assets/images/addb.png" class="img-fluid" alt="SEU">{{'admin.addexam' | translate}}</a>
      </div>
  </div> -->

 

       
  </nav>
</div>